export const useLifecycleStore = defineStore('lifecycle', () => {
  const initialized = ref(false)
  return {
    initialized,
  }
})
